/**
 * An organisation's security contacts (AIOE, 5 Nov 2026): the people and directory groups told at once of what a
 * security team must see, by an Inbox record that needs them and a push to their phones. Today: a decoy key used
 * by an agent, a change held back because it carried a secret, and a locked secret changed through break-glass.
 * With none named, the organisation's administrators are told. Every one of these is an audit row as well, which
 * forwarding and Microsoft Sentinel carry to the organisation's own tools.
 *
 *   GET /admin/v1/security-contacts   administrators: { contacts }
 *   PUT /admin/v1/security-contacts   administrators, after step-up: { contacts } → { contacts }
 */
import { z } from "zod";
export const securityContactSchema = z.object({
    subjectType: z.enum(["user", "group"]),
    subjectId: z.string().min(1).max(200),
});
export const securityContactsPutSchema = z.object({ contacts: z.array(securityContactSchema).max(50) });
//# sourceMappingURL=securityContacts.js.map